// extracted by mini-css-extract-plugin
export default {"container":"SubLayout_container__cBY32"};